import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconController24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconController24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.75 5.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5M6.25 4a2.25 2.25 0 0 0 0 4.5h3.5A2.25 2.25 0 0 0 11.872 7h7.378a.75.75 0 0 0 0-1.5h-7.378A2.25 2.25 0 0 0 9.75 4zm12.95 9a.75.75 0 0 0 0-1.5h-3.328A2.25 2.25 0 0 0 13.75 10h-3.5a2.25 2.25 0 0 0-2.122 1.5H4.75a.75.75 0 0 0 0 1.5h3.378a2.25 2.25 0 0 0 2.122 1.5h3.5a2.25 2.25 0 0 0 2.122-1.5zm-8.95-1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m1.878 7.5a2.25 2.25 0 0 0 2.122 1.5h3.5a2.25 2.25 0 0 0 0-4.5h-3.5a2.25 2.25 0 0 0-2.122 1.5H4.75a.75.75 0 0 0 0 1.5zm2.122-1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconController24);
